import { createSelector } from 'reselect';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getBookablePeriodOptions as getBookablePeriodOptionsHelper } from './helpers';

export const getBookablePeriodOptions = createSelector(getContainer, (container) => {
    const { appLocalizationComponent } = container();

    return getBookablePeriodOptionsHelper({
        localizeText: appLocalizationComponent.localizeText,
    });
});
